var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"equipment"},[_c('NewPie',{ref:"changePie",attrs:{"id":_vm.chartId,"option":_vm.activeOption,"bg":_vm.bgColor,"echartData":_vm.activeData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }